var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190,
    height: 90,
    viewBox: "0 0 190 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1048.795 -671.341)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1117.279 671.341)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.851 12.409)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.702,
    cy: 3.702,
    r: 3.702
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.728 12.409)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.702,
    cy: 3.702,
    r: 3.702
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1166.373,694l-9.264,9.916-4.677-4.879h-27.117a4.062,4.062,0,0,1,0-8.124,8.421,8.421,0,0,1,2.33.813,2.169,2.169,0,0,0,2.251-.263,2.273,2.273,0,0,0,.84-2.161,11.846,11.846,0,0,1-.159-1.938,11.68,11.68,0,0,1,15.155-11.144l.282.088,3.747-3.232-.816-.323a15.426,15.426,0,0,0-6.695-1.416,16.06,16.06,0,0,0-16.012,15.313,5.212,5.212,0,0,0-.923-.091,8.416,8.416,0,1,0,0,16.832h24.5l7.317,7.633,12.8-13.648Z",
    transform: "translate(-1116.898 -671.341)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1048.795 735.207)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.314)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1088.436,735.827c-6.41,0-13.327,4.722-13.327,12.35,0,7.826,5.48,13.293,13.327,13.293s13.326-5.467,13.326-13.293C1101.762,740.549,1094.845,735.827,1088.436,735.827Zm0,20.689a8.025,8.025,0,0,1-7.9-8.306c0-4.027,3.618-7.429,7.9-7.429s7.9,3.4,7.9,7.429A8.025,8.025,0,0,1,1088.436,756.516Z",
    transform: "translate(-1075.109 -735.827)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.744 0.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1106.279,760.627h8.643a11.98,11.98,0,1,0,0-23.957h-8.643Zm7.362-4.144h-2.207V740.814h2.275c4.84,0,7.969,3.075,7.969,7.834C1121.678,754.425,1117.526,756.483,1113.641,756.483Z",
    transform: "translate(-1106.279 -736.67)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.182 0.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1131.619,760.627h13.006v-4.144h-7.851v-5.83h7.447v-4.144h-7.447v-5.695h7.851V736.67h-13.006Z",
    transform: "translate(-1131.619 -736.67)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.712)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1072.242,741.4l-3.222,3.071a9.98,9.98,0,0,0-7.4-3.475,8.108,8.108,0,0,0-8.22,8.219,8.65,8.65,0,0,0,1.052,4.3,7.548,7.548,0,0,0,2.976,2.948,8.644,8.644,0,0,0,4.274,1.07,8.8,8.8,0,0,0,3.666-.749,13.15,13.15,0,0,0,3.65-2.726l3.123,3.259a17.144,17.144,0,0,1-5.068,3.63,13.827,13.827,0,0,1-5.446,1.013,12.533,12.533,0,0,1-9.239-3.58,12.385,12.385,0,0,1-3.595-9.172,12.562,12.562,0,0,1,1.637-6.434,12.178,12.178,0,0,1,4.69-4.525,13.228,13.228,0,0,1,6.573-1.711,13.951,13.951,0,0,1,10.547,4.863Z",
    transform: "translate(-1048.795 -736.539)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.358 0.131)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1168.551,760.627h5.525V736.67h-5.155v17.11l-1.364-1.856-11.879-15.254h-5.525v23.957h5.155V743.57l1.364,1.77Z",
    transform: "translate(-1150.153 -736.67)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.612 0.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1179.84,760.627h13.006v-4.144h-7.851v-5.83h7.446v-4.144h-7.446v-5.695h7.851V736.67H1179.84Z",
    transform: "translate(-1179.84 -736.67)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.34 0.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1212.234,760.627h6.668l-10.426-12.657,9.5-11.3H1211.7l-7.985,10.479h-.185V736.67h-5.155v23.957h5.155V749.609h.213Z",
    transform: "translate(-1198.373 -736.67)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(173.928 0.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1227.419,760.627h5.156V740.814h5.458V736.67h-16.072v4.144h5.458Z",
    transform: "translate(-1221.961 -736.67)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo_full.a74901366751e0ef7cc660fc3c73b971.svg";
export { ForwardRef as ReactComponent };